import { Component, OnInit, ElementRef, NgZone, ViewChild, Input, forwardRef, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup, FormArray, FormControl, FormBuilder, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, Validators } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';

import { SessionStorageService, PageContentService, ParameterConfigService } from '../../core/index.service';
import { PageContent } from '../../core/index.model';
import { ParamId } from '../../core/enumtype';

import { Address, NameAddress } from '../../core/index.model';

import { } from '@types/googlemaps';

import { CodeValue } from '../../core/index.model';

import { PhonePipe, ExtensionPipe } from '../pipes/index';

@Component({
    selector: 'pnx-geoaddress',
    templateUrl: './geoaddress.control.html',
    providers: [
        PhonePipe,
        ExtensionPipe,
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => GeoAddressControl), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => GeoAddressControl), multi: true }
    ]
})
export class GeoAddressControl implements OnInit, ControlValueAccessor, Validator {

    @Input() labelId: string = '';
    @Input() defaultLabel: string = '';
    @Input() placeholderId: string = '';
    @Input() defaultPlaceholder: string = '';

    @Input() pagecontent: PageContent;
    @Input() ReadOnly: boolean = false;
    @Input() Address: Address;
    @Input() NameAddress: NameAddress;
    @Input() readonlyCSZ: boolean = true;//Set readonly property to City | State | Zip

    @Input() AllowSpecificRegion: boolean = false;
    showInvalidAddress: boolean = false;

    addressForm: FormGroup;

    isValidAddress: boolean = false;
    isEdit: boolean = false;

    @ViewChild("searchAddr1") searchAddr1: ElementRef;

    codedValue: CodeValue[];

    constructor(
        private fb: FormBuilder,
        private ngZone: NgZone,
        private mapsAPILoader: MapsAPILoader,
        private storageService: SessionStorageService,
        private pagecontentService: PageContentService,
        public paramConfigService: ParameterConfigService,
        private extensionPipe: ExtensionPipe,
        private phonePipe: PhonePipe,
    ) { }


    ngOnInit() {
        this.formGroup();

        if (this.Address) {
            this.bindAddress(this.Address);
        }
        else if (this.NameAddress) {
            this.bindNameAddress(this.NameAddress);
        }

        if (this.pagecontent) {
            if (!this.pagecontentService.pageContent) {
                this.pagecontentService.pageContent = this.pagecontent;
            }
        }
    }


    ngAfterViewInit() {
        if (!this.ReadOnly) {
            this.getGoogleAddress("Address1", this.searchAddr1, this.addressForm.controls);
        }
    }
    //Disable the auto complete
    ngAfterViewChecked() {
        document.getElementsByName("cszAdd1")[0].setAttribute("autocomplete", "cszaddr1");
        document.getElementsByName("cszAdd2")[0].setAttribute("autocomplete", "cszaddr2");
        document.getElementsByName("cszCity")[0].setAttribute("autocomplete", "cszcity");
        document.getElementsByName("cszState")[0].setAttribute("autocomplete", "cszstate");
        document.getElementsByName("cszZip")[0].setAttribute("autocomplete", "cszZip");

    }
    // Control Value Accessor

    @Input() mandatory: boolean = false;
    @Input() mandateAll: boolean = true;
    @Input() showAddressOnly: boolean = false;
    @Input() containerstyle: string = 'row';
    @Input() labelstyle: string = 'control-label';
    @Input() textcontainerstyle: string = 'col-md-9';
    @Input() textboxstyle: string = 'w100c';
    @Input() placeholder: string = 'Address1';
    @Input() label: string = 'Address1';
    @Input('value') _value = '';
    @Input() disable: boolean = false;

    isInvalidCity: boolean = false;
    isInvalidState: boolean = false;
    isInvalidZip: boolean = false;
    disabled: boolean = false;

    ngOnChanges(Changes: SimpleChanges) {

        if (Changes['disable']) {
            this.setDisabledState(Changes['disable'].currentValue);
        }

        this.propagateChange(this.value);
        this.setMandatory(this.mandateAll);

        let labelValue = (this.labelId) ? this.pagecontentService.getKeyTxt(this.labelId, this.storageService.getLang()) : this.pagecontentService.getKeyTxt('Address_Address1', this.storageService.getLang());
        let placeHolderValue = (this.placeholderId) ? this.pagecontentService.getKeyTxt(this.placeholderId, this.storageService.getLang()) : this.placeholder;

        this.label = (labelValue) ? labelValue : this.defaultLabel;
        this.placeholder = (placeHolderValue) ? placeHolderValue : this.defaultPlaceholder;


    }

    text = new FormControl();

    propagateChange: any = () => { };

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.propagateChange(val);
    }

    writeValue(value): void {
        this.value = value;
        this.text.setValue(this.value);
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void { }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;

        if (this.disabled) {
            this.text.disable();
        }
        else {
            this.text.enable();
        }
    }

    public validate(parentControl: AbstractControl): { [key: string]: any } {

        const val = parentControl.value;

        if (this.mandatory) {

            this.text.setValidators(Validators.required);
            parentControl.setValidators(Validators.required);

            if (!parentControl.value) {
                parentControl.setValue(null);
            }

            if (!val) {
                return { valid: false };
            }
        }
        else {

            this.text.clearValidators();
            parentControl.clearValidators();

            if (!parentControl.value) {
                parentControl.setValue(null);
            }
        }

        return null;
    }


    // From Control Group

    formGroup() {

        this.addressForm = this.fb.group({

            // Address TBL
            AddressID: [],
            RefID: [],

            //NameAddress TBL
            AddrID: [],
            NameID: [],

            //Common
            JurisID: [],
            Premise: ["1"],
            Address1: [],
            Address2: [],
            State: [],
            StateName: [],
            City: [],
            Zip: [],
            Latitude: [],
            Longitude: []
        });

        this.setMandatory(this.mandateAll);

    }

    onZipChange(value: string) {
        const newValue: string = value;
        this.addressForm.controls.Zip.setValue(this.extensionPipe.transform(newValue));
    }

    setMandatory(isMandatory: boolean) {

        if (this.addressForm) {
            if (isMandatory) {
                this.addressForm.controls.Address1.setValidators(Validators.required);
                this.addressForm.controls.StateName.setValidators(Validators.required);
                this.addressForm.controls.City.setValidators(Validators.required);
                this.addressForm.controls.Zip.setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(5)]);
            }
            else {
                this.addressForm.controls.Address1.clearValidators();
                this.addressForm.controls.StateName.clearValidators();
                this.addressForm.controls.City.clearValidators();
                this.addressForm.controls.Zip.clearValidators();
            }

            this.addressForm.controls.Address1.updateValueAndValidity();
            this.addressForm.controls.StateName.updateValueAndValidity();
            this.addressForm.controls.City.updateValueAndValidity();
            this.addressForm.controls.Zip.updateValueAndValidity();
        }
    }

    // Initialize From Group If not initialized

    InitializeFormGroup() {
        if (this.addressForm) {
            this.formGroup();
        }
    }

    // Clear Form Values

    clearForm() {
        this.addressForm.reset();
        this.isValidAddress = false;
        this.isEdit = false;
    }

    // Google Address
    getCityStateByZip(zipCodeValue: any) {

        if (zipCodeValue && (zipCodeValue.length < 6 && zipCodeValue.length > 4)) {

            this.mapsAPILoader.load().then(() => {
                var _currentComponent = this;

                var City, State, StateName, Latitude, Longitude;

                var geoCoder = new google.maps.Geocoder();

                geoCoder.geocode({ 'address': zipCodeValue }, function (result, status) {
                    if (result[0]) {

                        City = result[0]['address_components'][1]['long_name'];
                        State = result[0]['address_components'].filter(row => row.types[0] == "administrative_area_level_1")[0].short_name;
                        StateName = result[0]['address_components'].filter(row => row.types[0] == "administrative_area_level_1")[0].long_name;
                        Latitude = result[0].geometry.location.lat();
                        Longitude = result[0].geometry.location.lng();

                        let addressCtrl = _currentComponent.addressForm.controls;
                        if (addressCtrl.City.value) {
                            _currentComponent.isInvalidCity = (addressCtrl.City.value.toLowerCase() == City.toLowerCase()) ? false : true;
                            if (_currentComponent.isInvalidCity) {

                                let latitude = _currentComponent.addressForm.controls.Latitude.value;
                                let longitude = _currentComponent.addressForm.controls.Longitude.value;

                                if (latitude != '' && latitude != undefined && longitude != '' && longitude != undefined) {
                                    if (latitude && longitude) {
                                        var geocoder = new google.maps.Geocoder();
                                        geocoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
                                            let addressCtrl = _currentComponent.addressForm.controls;

                                            if (results[0]) {
                                                City = (results[0].address_components.filter(item => item.types[0] === "locality").length > 0 ? results[0].address_components.filter(item => item.types[0] === "locality")[0].long_name : '');
                                          
                                                    _currentComponent.addressForm.controls.City.setValue(City);
                                                _currentComponent.isInvalidCity = (addressCtrl.City.value.toLowerCase() == City.toLowerCase()) ? false : true;
                                            }
                                            

                                        });
                                    }
                                }
                            }
                        }
                        addressCtrl.City.setValue(City);
                        addressCtrl.State.setValue(State);
                        addressCtrl.StateName.setValue(StateName);
                        addressCtrl.Latitude.setValue(Latitude);
                        addressCtrl.Longitude.setValue(Longitude);

                        _currentComponent.isValidAddress = true;

                        if (_currentComponent.AllowSpecificRegion) {
                            _currentComponent.allowSpecificRegion(zipCodeValue);
                        }
                    }
                    else {
                        if (_currentComponent.AllowSpecificRegion) {
                            _currentComponent.allowSpecificRegion(zipCodeValue);
                        }
                    }
                });

            });

            //if (this.AllowSpecificRegion) {
            //    this.allowSpecificRegion(zipCodeValue);
            //}
        }
        else {
            if (!zipCodeValue) {
                this.addressForm.controls.City.setValue('');
                this.addressForm.controls.State.setValue('');
                this.addressForm.controls.StateName.setValue('');
                this.addressForm.controls.Latitude.setValue('');
                this.addressForm.controls.Longitude.setValue('');
            }
        }
    }

    getGoogleAddress(flag: string, searchAddrElementRef: ElementRef, frmContorl: any) {

        this.mapsAPILoader.load().then(() => {

            let autocomplete = new google.maps.places.Autocomplete(searchAddrElementRef.nativeElement, {
                types: ["address"],
                componentRestrictions: { country: "us" }
            });

            autocomplete.addListener("place_changed", () => {

                this.ngZone.run(() => {
                    let place: google.maps.places.PlaceResult = autocomplete.getPlace();

                    //verify result
                    if (place === undefined || place === null || place.geometry === undefined || place.geometry === null) {
                        return;
                    }

                    if (frmContorl.Address1) {

                        this.isValidAddress = true;

                        this.setGooglePlaceResult(place);
                    }
                    else {
                        this.value = (place.address_components.filter(item => item.types[0] === "street_number").length > 0 ? place.address_components.filter(item => item.types[0] === "street_number")[0].long_name + " " : '')
                            + (place.address_components.filter(item => item.types[0] === "route").length > 0 ? place.address_components.filter(item => item.types[0] === "route")[0].long_name : '');
                    }

                });
            });

        });

    }

    setGooglePlaceResult(place: google.maps.places.PlaceResult) {

        this.addressForm.controls.Address1.setValue(
            (place.address_components.filter(item => item.types[0] === "street_number").length > 0 ? place.address_components.filter(item => item.types[0] === "street_number")[0].long_name + " " : '')
            + (place.address_components.filter(item => item.types[0] === "route").length > 0 ? place.address_components.filter(item => item.types[0] === "route")[0].long_name : '')
        );

        this.addressForm.controls.City.setValue(
            (place.address_components.filter(item => item.types[0] === "locality").length > 0 ? place.address_components.filter(item => item.types[0] === "locality")[0].long_name : '')
        );

        this.addressForm.controls.State.setValue(
            (place.address_components.filter(item => item.types[0] === "administrative_area_level_1").length > 0 ? place.address_components.filter(item => item.types[0] === "administrative_area_level_1")[0].short_name : '')
        );

        this.addressForm.controls.StateName.setValue(
            (place.address_components.filter(item => item.types[0] === "administrative_area_level_1").length > 0 ? place.address_components.filter(item => item.types[0] === "administrative_area_level_1")[0].long_name : '')
        );

        this.addressForm.controls.Zip.setValue(
            place.address_components.filter(item => item.types[0] === "postal_code").length > 0 ? place.address_components.filter(item => item.types[0] === "postal_code")[0].long_name : ''
        );

        this.addressForm.controls.Latitude.setValue(place.geometry.location.lat());
        this.addressForm.controls.Longitude.setValue(place.geometry.location.lng());

        if (this.addressForm.controls.Address1.value === '' || this.addressForm.controls.StateName.value === '' || this.addressForm.controls.City.value === '' || this.addressForm.controls.Zip.value === '') {
            this.isValidAddress = false;
        }

        this.value = this.addressForm.controls.Address1.value;

        if (this.AllowSpecificRegion) {
            let postelCode = place.address_components.filter(item => item.types[0] === "postal_code").length > 0 ? place.address_components.filter(item => item.types[0] === "postal_code")[0].long_name : ''
            this.allowSpecificRegion(postelCode);
        }
        this.ValidateZip(this.addressForm.controls.Zip.value);
        this.ValidateCity(this.addressForm.controls.Zip.value);
    }

    allowSpecificRegion(postelCode: any) {
        let paramValue: string = (this.paramConfigService.GetSystemParamValue(ParamId.AllowedZipCodes)) ? this.paramConfigService.GetSystemParamValue(ParamId.AllowedZipCodes) : this.storageService.getJurisZip();

        if (paramValue != "*" && paramValue != "") {

            let parmValueArray: string[] = paramValue.match(/.{1,5}/g);

            if (parmValueArray.includes(postelCode)) {
                this.isValidAddress = true;

                this.showInvalidAddress = false;
            }
            else {

                this.isValidAddress = false;

                this.showInvalidAddress = true;
            }
        }
    }

    // Get State Name from latitude and longitude

    getStateNameFromLatLng(latitude: number, longitude: number) {

        if (latitude && longitude) {
            this.mapsAPILoader.load().then(() => {

                var geocoder = new google.maps.Geocoder();

                var result = "";
                geocoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
                    let addressCtrl = this.addressForm.controls;
                    addressCtrl.StateName.setValue(
                        (results[0].address_components.filter(item => item.types[0] === "administrative_area_level_1").length > 0 ? results[0].address_components.filter(item => item.types[0] === "administrative_area_level_1")[0].long_name : '')
                    );

                    if (this.addressForm.controls.Address1.value && this.addressForm.controls.City.value && this.addressForm.controls.StateName.value && this.addressForm.controls.Zip.value) {
                        this.isValidAddress = true;
                    }
                    else {
                        this.isValidAddress = false;
                    }
                });
            });
        }

    }

    onAddrChange() {
        this.isValidAddress = false;
    }

    // Bind Address Value to Form Controls

    bindAddress(objAddress: Address) {

        if (objAddress && this.addressForm) {

            this.isEdit = true;

            this.Address = objAddress;

            this.InitializeFormGroup();

            this.addressForm.controls.AddressID.setValue(objAddress.AddressID);
            this.addressForm.controls.RefID.setValue(objAddress.RefID);

            this.addressForm.controls.JurisID.setValue(objAddress.JurisID);
            this.addressForm.controls.Address1.setValue(objAddress.Address1);
            this.addressForm.controls.Address2.setValue(objAddress.Address2);
            this.addressForm.controls.City.setValue(objAddress.City);
            this.addressForm.controls.State.setValue(objAddress.State);
            this.addressForm.controls.Zip.setValue(objAddress.Zip);
            this.addressForm.controls.Latitude.setValue(objAddress.Latitude);
            this.addressForm.controls.Longitude.setValue(objAddress.Longitude);

            this.getStateNameFromLatLng(objAddress.Latitude, objAddress.Longitude);

            if (this.addressForm.controls.Zip.value) {
                this.ValidateZip(this.addressForm.controls.Zip.value);
                this.ValidateCity(this.addressForm.controls.Zip.value);
            }
        }
    }

    ValidateZip(zipCode: any) {
        var _currentComponent = this;
        if (zipCode && (zipCode.length < 6 && zipCode.length > 4)) {
            if (this.readonlyCSZ == false) {
                this.mapsAPILoader.load().then(() => {

                    var address = this.addressForm.controls.Address1.value;
                    var geoCoder = new google.maps.Geocoder();

                    geoCoder.geocode({ 'address': address }, function (result, status) {

                        let addressCtrl = _currentComponent.addressForm.controls;

                        if (result != null && result.length > 0 && result[0]) {
                            var Zip = (result[0].address_components.filter(item => item.types[0] === "postal_code").length > 0 ? result[0].address_components.filter(item => item.types[0] === "postal_code")[0].long_name : '');
                            _currentComponent.isInvalidZip = (addressCtrl.Zip.value == Zip) ? false : true;

                            if (_currentComponent.isInvalidZip == false) {
                                _currentComponent.addressForm.controls.Zip.setValue(Zip);
                            }
                        }
                        else {
                            _currentComponent.isInvalidZip = true;
                        }

                        if (_currentComponent.isInvalidZip) {
                            let latitude = _currentComponent.addressForm.controls.Latitude.value;
                            let longitude = _currentComponent.addressForm.controls.Longitude.value;

                            if (latitude != '' && latitude != undefined && longitude != '' && longitude != undefined) {
                                if (latitude && longitude) {

                                    geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
                                        if (results != null && results.length > 0 && results[0]) {

                                            var Zip = (results[0].address_components.filter(item => item.types[0] === "postal_code").length > 0 ? results[0].address_components.filter(item => item.types[0] === "postal_code")[0].long_name : '');
                                            _currentComponent.isInvalidZip = (addressCtrl.Zip.value == Zip) ? false : true;

                                            if (_currentComponent.isInvalidZip == false) {
                                                _currentComponent.addressForm.controls.Zip.setValue(Zip);
                                            }
                                        }
                                        else {
                                            _currentComponent.isInvalidZip = true;
                                        }
                                    });
                                }
                            }
                        }
                    });
                });
            }
        }
        else {
            _currentComponent.isInvalidZip = true;
        }
    }

    ValidateCity(zipCodeValue: any) {

        if (zipCodeValue) {
            if (this.readonlyCSZ == false) {
                var _currentComponent = this;
                this.mapsAPILoader.load().then(() => {
                    var StateName;
                    var State;
                    var City;

                    var geoCoder = new google.maps.Geocoder();

                    geoCoder.geocode({ 'address': zipCodeValue.toString() }, function (result, status) {

                        if (result[0]) {

                            City = result[0]['address_components'][1]['long_name'];
                            State = result[0]['address_components'][3]['short_name'];
                            StateName = result[0]['address_components'][3]['long_name'];

                            let addressCtrl = _currentComponent.addressForm.controls;

                            _currentComponent.isInvalidCity = (addressCtrl.City.value.toLowerCase() == City.toLowerCase()) ? false : true;

                            let addrsForm = _currentComponent.getAddress();
                            if (addrsForm.StateName != null) {
                                _currentComponent.isInvalidState = (addrsForm.StateName.toLowerCase() == StateName.toLowerCase()) ? false : true;
                            }

                            if (_currentComponent.isInvalidCity == false) {
                                _currentComponent.addressForm.controls.City.setValue(City);
                            }
                            if (_currentComponent.isInvalidState == false) {
                                _currentComponent.addressForm.controls.State.setValue(State);
                            }
                        }
                        else {
                            _currentComponent.isInvalidCity = true;
                            _currentComponent.isInvalidState = true;
                        }
                        if (_currentComponent.isInvalidCity || _currentComponent.isInvalidState) {

                            let latitude = _currentComponent.addressForm.controls.Latitude.value;
                            let longitude = _currentComponent.addressForm.controls.Longitude.value;

                            if (latitude != '' && latitude != undefined && longitude != '' && longitude != undefined) {
                                if (latitude && longitude) {
                                    var geocoder = new google.maps.Geocoder();
                                    geocoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
                                        let addressCtrl = _currentComponent.addressForm.controls;

                                        if (results[0]) {
                                            var City = (results[0].address_components.filter(item => item.types[0] === "locality").length > 0 ? results[0].address_components.filter(item => item.types[0] === "locality")[0].long_name : '');
                                            _currentComponent.isInvalidCity = (addressCtrl.City.value.toLowerCase() == City.toLowerCase()) ? false : true;

                                            var State = (results[0].address_components.filter(item => item.types[0] === "administrative_area_level_1").length > 0 ? results[0].address_components.filter(item => item.types[0] === "administrative_area_level_1")[0].short_name : '');

                                            var StateName = (results[0].address_components.filter(item => item.types[0] === "administrative_area_level_1").length > 0 ? results[0].address_components.filter(item => item.types[0] === "administrative_area_level_1")[0].long_name : '');
                                            _currentComponent.isInvalidState = (addressCtrl.StateName.value.toLowerCase() == StateName.toLowerCase()) ? false : true;


                                            if (_currentComponent.isInvalidCity == false) {
                                                _currentComponent.addressForm.controls.City.setValue(City);
                                            }
                                            if (_currentComponent.isInvalidState == false) {
                                                _currentComponent.addressForm.controls.State.setValue(State);
                                            }
                                        }
                                        else {
                                            _currentComponent.isInvalidCity = true;
                                            _currentComponent.isInvalidState = true;
                                        }

                                    });
                                }
                            }
                        }

                    });

                });
            }
        }
    }

    // Bind Name Address Value to Form Controls

    bindNameAddress(objAddress: NameAddress) {

        if (objAddress && this.addressForm) {

            this.isEdit = true;

            this.NameAddress = objAddress;

            this.InitializeFormGroup();

            this.addressForm.controls.AddrID.setValue(objAddress.AddrID);
            this.addressForm.controls.NameID.setValue(objAddress.NameID);

            this.addressForm.controls.JurisID.setValue(objAddress.JurisID);
            this.addressForm.controls.Address1.setValue(objAddress.Address1);
            this.addressForm.controls.Address2.setValue(objAddress.Address2);
            this.addressForm.controls.City.setValue(objAddress.City);
            this.addressForm.controls.State.setValue(objAddress.State);
            this.addressForm.controls.Zip.setValue(objAddress.Zip);
            this.addressForm.controls.Latitude.setValue(objAddress.Latitude);
            this.addressForm.controls.Longitude.setValue(objAddress.Longitude);

            this.getStateNameFromLatLng(objAddress.Latitude, objAddress.Longitude);
        }

    }

    // Get the Address Details from Form Controls

    getAddress(): Address {

        this.markAsTouched();

        this.setIDFields();

        return this.addressForm.value;
    }

    setIDFields() {
        if (!this.isEdit) {
            this.addressForm.controls.JurisID.setValue(this.storageService.getJurisNo());

            if (this.Address) {
                this.addressForm.controls.AddressID.setValue(this.Address.AddressID);
                this.addressForm.controls.RefID.setValue(this.Address.RefID);
                this.addressForm.controls.JurisID.setValue(this.Address.JurisID);
            }

            if (this.NameAddress) {
                this.addressForm.controls.AddrID.setValue(this.NameAddress.AddrID);
                this.addressForm.controls.NameID.setValue(this.NameAddress.NameID);
                this.addressForm.controls.JurisID.setValue(this.NameAddress.JurisID);
            }
        }
    }

    // Get the Name Address Details from Form Controls

    getNameAddress(): NameAddress {

        this.markAsTouched();

        if (!this.isEdit) {
            this.addressForm.controls.JurisID.setValue(this.storageService.getJurisNo());
        }

        return this.addressForm.value;
    }

    // To Highlight Mandatory Fields

    markAsTouched() {
        this.addressForm.controls.Address1.markAsTouched();
        this.addressForm.controls.City.markAsTouched();
        this.addressForm.controls.StateName.markAsTouched();
        this.addressForm.controls.Zip.markAsTouched();
    }
 
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/geoaddress.control.ts